import { useLang } from '@/i18n';
import EcoWhatInBox from 'eco-design/sections/eco-what-in-box';
export default function Comp() {
    const { t } = useLang('theProduct');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351207218/WAVE%203.png',
            title: t('O_tab1_text1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351207966/Insulated%20Exhaust%20Duct.png',
            title: t('O_tab1_text2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351207403/Exhaust%20Duct%20Adapter%20Covers%20(A%2C%20B%2C%20C).png',
            title: t('O_tab1_text3'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351206873/Drain%20Pipe.png',
            title: t('O_tab1_text4'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351207039/Winder.png',
            title: t('O_tab1_text5'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351207582/Duct%20Size%20Template.png',
            title: t('O_tab1_text6'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750995164267/4.png',
            title: t('O_tab1_text7'),
        },
    ];
    return (
        <>
            <EcoWhatInBox items={itemsA} />
        </>
    );
}
